/**
 * Returns the Curacao states list to populate the select item.
 */
export function gluky_addressfield_cu_states_list() {
  let temporalStates = [];
  const states =
  {
    '00': 'Banda abou',
    '01': 'Labadera',
    '02': 'Saliña',
    '03': 'Sint Michiel',
    '04': 'Willemstad'
  }

  Object.keys(states).map((res) => {
    temporalStates = [
      ...temporalStates,
      {
        name: states[res],
        code: res,
      },
    ];
  });
  return temporalStates;
}

/**
 * Returns the Curacao cities list by state code to populate the select item.
 *
 * @param $state_code
 *   The DANE state code
 * @return
 */
export function gluky_addressfield_cu_cities_list($state_code) {
  let temporalCities = [];
  const $data = {
    '00': {
      '0001': 'Barber',
      '0002': 'Bisento',
      '0003': 'Christoffelpark, National Park Christoffel',
      '0004': 'Daniel',
      '0005': 'Grote Berg‎',
      '0006': 'Jan Donker',
      '0007': 'Jan Kok',
      '0008': 'Lagun',
      '0009': 'Leliënberg',
      '0010': 'Sabana Westpunt',
      '0011': 'Seru Grandi',
      '0012': 'Sint Willibrordus',
      '0013': 'Soto',
      '0014': 'Tera Korá',
      '0015': 'Westpunt',
    },
    '01': {
      '0101': 'Labadera'
    },
    '02': {
      '0201': 'Moko',
      '0202': 'Nieuwpoort',
    },
    '03': {
      '0301': 'Boka Samí',
      '0302': 'Sint Michiel',
    },
    '04': {
      '0401': 'Brievengat',
      '0402': 'Buena Vista',
      '0403': 'Charo',
      '0404': 'Charo',
      '0405': 'Emmastad',
      '0406': 'Groot Davelaar',
      '0407': 'Groot Piscadera',
      '0408': 'Habaai',
      '0409': 'Julianadorp',
      '0410': 'Kanga/Deina',
      '0411': 'Landhuis Hato',
      '0412': 'Landhuis Hato, Hato International Airport (Franklin D. Rooseveltweg)',
      '0413': 'Mahuma',
      '0414': 'Marchena',
      '0415': 'Montaña Abou',
      '0416': 'Montaña Rey',
      '0417': 'Mundo Nobo',
      '0418': 'Nieuw Nederland',
      '0419': 'Nieuwe Haven',
      '0420': 'Otrobanda',
      '0421': 'Parera',
      '0422': 'Piscadera',
      '0423': 'Punda',
      '0424': 'Ronde Klip',
      '0425': 'Rooi Catochi',
      '0426': 'Roosendaal',
      '0427': 'Saliña',
      '0428': 'Saliña Harbour View',
      '0429': 'Santa Catharina',
      '0430': 'Santa Maria   ',
      '0431': 'Santa Rosa',
      '0432': 'Scherpenheuvel',
      '0433': 'Seru Fortuna',
      '0434': 'Sint Jacob',
      '0435': 'Souax',
      '0436': 'Souax',
      '0437': 'Sun Valley',
      '0438': 'Sunset Heights',
      '0439': 'Wacao',
      '0440': 'Wanapa',
      '0441': 'Welgelegen',
      '0442': 'Willemstad',
      '0443': 'Wishi',
    }
  }
  const cities = $data[$state_code] ? $data[$state_code] : null;
  Object.keys(cities).map((citie) => {
    temporalCities = [
      ...temporalCities,
      {
        name: cities[citie],
        code: citie,
      },
    ];
  });
  return temporalCities;
}

